import React, { useRef } from "react";
import { useDrag } from "react-dnd";
import { Resizable } from "react-resizable";
import { useState } from "react";
import "react-resizable/css/styles.css";
import {
  MinusSmallIcon,
  ArrowDownIcon,
  ArrowUpIcon,
} from "@heroicons/react/20/solid";

const DraggableCard = ({
  x = 0,
  y = 0,
  title,
  count,
  change,
  previousStat,
  changeType,
  name,
}) => {
  const [{ isDragging }, drag] = useDrag({
    type: "CARD",
    item: { id: name, type: "CARD", x, y }, // Use name as the ID
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [currentSize, setCurrentSize] = useState({
    width: 250, // Default width for the card
    height: 150, // Default height for the card
  });

  const handleResize = (event, data) => {
    const { width, height } = data.size;
    setCurrentSize({ width, height });
  };

  const opacity = isDragging ? 0.5 : 1;

  const cardWrapperStyle = {
    position: "relative",
    width: `${currentSize.width}px`,
    height: `${currentSize.height}px`,
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const dynamicSize = `calc(${currentSize.width}px * 0.06)`;
  const dynamicSizeForMainNumber = `calc(${currentSize.width}px * 0.15)`;
  const dynamicSizeForSmallTextInBottom = `calc(${currentSize.width}px * 0.05)`;
  return (
    <div
      style={{
        position: "absolute",
        left: x,
        top: y,
        opacity,
        border: "solid black 1px",
        zIndex: 10,
      }}
    >
      <Resizable
        width={currentSize.width}
        height={currentSize.height}
        onResize={handleResize}
        lockAspectRatio={true}
      >
        <div style={cardWrapperStyle}>
          <div ref={drag} className="cursor-move flex relative top-2 right-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6 absolute top-0 left-2 "
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
              />{" "}
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6 absolute top-0 left-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
              />{" "}
            </svg>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
              padding: "1rem",
              background: "#f7f7f7",
              borderRadius: "4px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              paddingLeft: "30px",
            }}
          >
            {/* Top Section: Name & Change */}

            <div className="flex justify-between items-center">
              <dt
                className="text-sm font-medium text-gray-500"
                style={{ fontSize: dynamicSize }}
              >
                {title}
              </dt>
              <dd className="flex items-center">
                {
                  changeType === "increase" ? (
                    <>
                      <ArrowUpIcon
                        style={{ width: dynamicSize, height: dynamicSize }}
                        className="mr-1 text-green-500"
                        aria-hidden="true"
                      />
                      <span
                        className="text-xs font-medium text-green-500"
                        style={{ fontSize: dynamicSize }}
                      >
                        {change}
                      </span>
                    </>
                  ) : changeType === "decrease" ? (
                    <>
                      <ArrowDownIcon
                        style={{ width: dynamicSize, height: dynamicSize }}
                        className="mr-1 text-red-500"
                        aria-hidden="true"
                      />
                      <span
                        className="text-xs font-medium text-red-500"
                        style={{ fontSize: dynamicSize }}
                      >
                        {change}
                      </span>
                    </>
                  ) : (
                    <MinusSmallIcon
                      style={{ width: dynamicSize, height: dynamicSize }}
                      aria-hidden="true"
                    />
                  ) /* (
                  <span
                    className="text-xs font-medium text-gray-700"
                    style={{ fontSize: dynamicSize }}
                  >
                    {change}
                  </span>
                ) */
                }
              </dd>
            </div>

            {/* Main Value */}
            <dd
              className="text-3xl font-medium text-gray-900"
              style={{ fontSize: dynamicSizeForMainNumber }}
            >
              {count}
            </dd>

            {/* Bottom details */}
            <div className=" items-center mt-2">
              <span
                className="text-xs font-medium text-gray-500"
                style={{ fontSize: dynamicSizeForSmallTextInBottom }}
              >
                {title === "Improved Keywords"
                  ? "since yesterday"
                  : change === 0
                  ? `also ${previousStat} yesterday`
                  : previousStat !== null
                  ? `from ${previousStat} yesterday`
                  : ""}
              </span>
            </div>
          </div>
        </div>
      </Resizable>
    </div>
  );
};

export default DraggableCard;
